import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MessageCrudService} from "@evomatik/evk-common";

@Component({
    selector: 'lib-actualizacion-dialog',
    templateUrl: './actualizacion-dialog.component.html',
    styleUrls: ['./actualizacion-dialog.component.css']
})
export class ActualizacionDialogComponent implements OnInit {

    tipos = [];

    tipo = "";

    constructor(
        public messageCrudService: MessageCrudService,
        public dialogRef: MatDialogRef<ActualizacionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.tipos = this.data;
    }

    ngOnInit(): void {
    }

    changeTipo(event) {
        this.tipo = event;
    }

    save() {
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿Está seguro de actualizar el expediente con esta configuración? ',
            goonbtn: 'Actualizar'
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.dialogRef.close(this.tipo);
            confirmDialog.close();
        });
    }
}
